module.exports = __webpack_public_path__ + "static/media/deptimage3.84113a2f.JPG";